import { Component, Input, OnInit } from '@angular/core';
import { BoxHistoricoAcoesService } from '../box-historico-acoes/box-historico-acoes.service';
import { environment } from '../../environments/environment';
import { GraphicService } from '../shared/graphic.service';
import { ConfiguracaoInfoCliente, SituacaoOdometro, TipoEntregas, TipoRoteiro, Util } from '../shared/Util';
import { FilterPipe } from '../../pipes/pesquisa/pesquisa.pipe';
import { isNull } from 'is-what';
import { SvgService } from '../shared/svg.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BoxInfoRouterService } from '../box-info-router/box-info-router.service';
import { NotificationService } from '../shared/notification.service';
import { FormsModule } from '@angular/forms';
import { NgFor, NgIf, NgClass, DatePipe } from '@angular/common';
import { BarDateComponent } from '../shared/componentes/bar-date/bar-date.component';
import { TextoLinkComponent } from '../shared/componentes/texto-link/texto-link.component';

declare var $: any;
declare var bootstrap: any;

@Component({
    selector: 'box-historico-acoes',
    templateUrl: './box-historico-acoes.component.html',
    styleUrls: ['./box-historico-acoes.component.css'],
    standalone: true,
    imports: [FormsModule, NgFor, BarDateComponent, NgIf, TextoLinkComponent, NgClass, DatePipe, FilterPipe]
})
export class BoxHistoricoAcoesComponent implements OnInit {

  infoHistoricoAcoes: any;
  infoCoordenadasRota: any;
  pesquisaAcoes: any;
  iconeAcao: any;
  acoesSepPorDia = [];
  agrupadoDiaCliente = [];
  exibirTodos = false;
  kmOdometroInicio = null
  kmOdometroFinal = null
  mostraComprovanteApp = false;
  configNomeClienteExibicao = ConfiguracaoInfoCliente.RazaoSocial;
  enumConfiguracaoInfoCliente = ConfiguracaoInfoCliente;
  @Input() roteiro: any;
  @Input() roteiroCrossdocking: boolean = false;

  constructor
    (
      private boxHistoricoAcoesService: BoxHistoricoAcoesService,
      private graphicService: GraphicService,
      private util: Util,
      public svgService:SvgService,
      public sanitizer:DomSanitizer,
      private boxInfoRouterService: BoxInfoRouterService,
      private notificationService: NotificationService
    ) { }

  async ngOnInit() {
    setTimeout(() => { this.getHistoryAction(); }, 500);
  }

  async getHistoryAction() {
    let infoRota = JSON.parse(this.roteiro.InfoRota);
    if(infoRota.ConfigNomeClienteExibicao){
      this.configNomeClienteExibicao = infoRota.ConfigNomeClienteExibicao
    }

    await this.boxHistoricoAcoesService.getHistoryAction();

    this.infoHistoricoAcoes = this.boxHistoricoAcoesService.listHistoryAction.filter
      (
        x => (x.CodigoAcao != 1 && x.CodigoAcao != 7) || x.IdRoteiroSituacao != null || x.IdRoteiroPedidoSituacao != null
      );

    this.infoCoordenadasRota = this.boxHistoricoAcoesService.listHistoryAction.filter
      (
        x => x.CodigoAcao === 1 && x.Latitude != 0
      );

    let codigoCliente = 0
    let contador = 1;
    for (let i = 0; i < this.infoHistoricoAcoes.length; i++) {

      if (codigoCliente == 0) {
        codigoCliente = this.infoHistoricoAcoes[i].CodigoCliente;
      }

      if(this.infoHistoricoAcoes[i].CodigoAcao == 20){
        let informacoes = JSON.parse(this.infoHistoricoAcoes[i].Informacoes);
        this.infoHistoricoAcoes[i].km = informacoes.situacaoOdometro == SituacaoOdometro.Inicio? this.roteiro.KmOdometroInicio : this.roteiro.KmOdometroFinal;
      }
      
      let codigo = this.infoHistoricoAcoes[i].CodigoCliente != 0 ? this.infoHistoricoAcoes[i].CodigoCliente : 0;

      this.infoHistoricoAcoes[i].Data = this.util.converterDataSemFuso(this.infoHistoricoAcoes[i].Data);
      this.infoHistoricoAcoes[i].posicaoCliente = this.graphicService.posicaoCliente[codigo.toString()];
      let posicaoCliente = this.graphicService.posicaoCliente[codigo.toString()] == undefined ? null : this.graphicService.posicaoCliente[codigo.toString()];

      let options = { icone: "RotaClienteSel", alerta: "nada", cor: "515356", index: posicaoCliente, RHorario: false, RFeriado: false, RPedido: false, RAgendada: false, Opacidade: 1 }
      this.infoHistoricoAcoes[i].urlIcone =this.sanitizer.bypassSecurityTrustResourceUrl(this.svgService.geraSVG(options))
      this.infoHistoricoAcoes[i].Acao = this.retornaAcao(this.infoHistoricoAcoes[i]);

      if (posicaoCliente == null) {

        let options = { icone: "RotaClienteSel", alerta: "nada", cor: "515356", index:  contador , RHorario: false, RFeriado: false, RPedido: false, RAgendada: false, Opacidade: 1 }


        this.infoHistoricoAcoes[i].urlIcone= this.sanitizer.bypassSecurityTrustResourceUrl(this.svgService.geraSVG(options))

        if (this.infoHistoricoAcoes[i].CodigoCliente !== codigoCliente) {
          codigoCliente = this.infoHistoricoAcoes[i].CodigoCliente;
          contador = contador + 1
        }
      }
    }

    /// GRAVA ICONE HISTORICO

    this.infoHistoricoAcoes.forEach((item)=>{
      item.iconeAcao = this.retornaIcone(item)
    })

    let pontosComUltimaPosicao = this.boxHistoricoAcoesService.listHistoryAction.filter
      (
        x => (x.CodigoAcao === 1 || x.CodigoAcao === 7) && x.Latitude != 0
      );


    if(this.infoHistoricoAcoes.length){
      const dataReferencia = this.infoHistoricoAcoes[0].Data;
      for (let i = 0; i < this.infoHistoricoAcoes.length; i++) {
          const diferenca = Util.calcularDiferencaDias(dataReferencia, this.infoHistoricoAcoes[i].Data);         
          this.infoHistoricoAcoes[i].dia = diferenca; 
      }
    }      

    let listaAgrupadaPorDia = {};
    this.infoHistoricoAcoes.forEach(item => {
        if (!listaAgrupadaPorDia[item.dia]) {
            listaAgrupadaPorDia[item.dia] = [];
        }
        listaAgrupadaPorDia[item.dia].push(item);
    });

    this.acoesSepPorDia = Object.values(listaAgrupadaPorDia);
    let clientesAgrupados = {};  
    this.acoesSepPorDia.forEach(dia => {
      dia.forEach(cliente => {
        if (cliente.CodigoCliente != 0) {
          if (!clientesAgrupados[cliente.CodigoCliente]) {
              clientesAgrupados[cliente.CodigoCliente] = [];
          }
          clientesAgrupados[cliente.CodigoCliente].push(cliente);
        }
      });

      let agrupadoDiaCliente = [];
      
      dia.forEach(cliente => {
          if (cliente.CodigoCliente == 0) {
              agrupadoDiaCliente.push([cliente]);
          } else if (clientesAgrupados[cliente.CodigoCliente]) {
              agrupadoDiaCliente.push(clientesAgrupados[cliente.CodigoCliente]);
              delete clientesAgrupados[cliente.CodigoCliente];
          }
      });

      this.agrupadoDiaCliente.push(agrupadoDiaCliente)
    });  

    this.graphicService.visualizarPontosMapa(this.infoCoordenadasRota, pontosComUltimaPosicao);
    this.graphicService.atualizaMapView();
    this.kmOdometroInicio = this.roteiro.KmOdometroInicio ?? null;
    this.kmOdometroFinal = this.roteiro.KmOdometroFinal ?? null;
    this.mostraComprovanteApp = infoRota.ConfigRecebimentoApp == '0' ? false : true;    
  }


  retornaAcao(item) {
    let informacoes = JSON.parse(item.Informacoes)        
    if(item.CodigoAcao == 20) {
     
      return informacoes.situacaoOdometro == SituacaoOdometro.Inicio?  'Odômetro - Registro Inicial' : 'Odômetro - Registro Final' ;
    }

    let codigo = 0;
    let retorno: string;

    if (isNull(item.IdRoteiroSituacao) && isNull(item.IdRoteiroPedidoSituacao)) {
      codigo = item.CodigoAcao;

      switch (codigo) {
        case 1: retorno = 'Coordenada'; break;
        case 2: retorno = 'Sincronização'; break;
        case 3: retorno = 'Check-in'; break;
        case 6: retorno = 'Ocorrência'; break;
        case 13: retorno = 'Roteiro - Pausado'; break;
        case 14: retorno = 'Roteiro - Entrou novamente'; break;
      }
    } else if (!isNull(item.IdRoteiroSituacao)) {
      codigo = item.IdRoteiroSituacao;
      switch (codigo) {
        case 1: retorno = this.roteiroCrossdocking ? 'Crossdocking - Novo' : 'Roteiro - Novo'; break;
        case 2: retorno = this.roteiroCrossdocking ? 'Crossdocking - Iniciado' : 'Roteiro - Iniciado'; break;
        case 3: retorno = this.roteiroCrossdocking ? 'Crossdocking - Pausado' : 'Roteiro - Pausado'; break;
        case 4: retorno = this.roteiroCrossdocking ? 'Crossdocking - Saída' : 'Roteiro - Saída'; break;
        case 5: retorno = this.roteiroCrossdocking ? 'Crossdocking - Finalizado' : 'Roteiro - Finalizado'; break;
      }
    } else {
      codigo = item.IdRoteiroPedidoSituacao;
      switch (codigo) {
        case 1: retorno = 'Entrega em aberto'; break;
        case 2: retorno = 'Check-in'; break;
        case 3: retorno = informacoes.tipo == TipoEntregas.Coleta ? 'Início da Coleta' :  'Início da Entrega'; break; //RotaGPSAcao4
        case 4: retorno = 'Volto depois'; break; //RotaGPSAcao
        case 5: retorno = informacoes.tipo == TipoEntregas.Coleta ? 'Coleta não efetuada' :'Recebimento recusado'; break; //RotaGPSAcao
        case 6: retorno = informacoes.tipo == TipoEntregas.Coleta ? 'Coleta realizada' : 'Entrega realizada'; break;
        case 7: retorno = informacoes.tipo == TipoEntregas.Coleta ? 'Coleta realizada com exceção' : 'Entrega realizada com exceção'; break;
      }
    }
    return retorno;
  }

  retornaIcone(item) {
    let informacoes = JSON.parse(item.Informacoes)
    let codigo = 0;
    let icone: string;

    if (isNull(item.IdRoteiroSituacao) && isNull(item.IdRoteiroPedidoSituacao)) {
      codigo = item.CodigoAcao;
    } else if (!isNull(item.IdRoteiroSituacao)) {
      switch (item.IdRoteiroSituacao) {
        case 1: codigo = 18; break;  //Roteiro - Novo
        case 2: codigo = 8; break; //Roteiro - Iniciado
        case 3: codigo = 9; break; //Roteiro - Pausado
        case 4: codigo = 10; break; //Roteiro - Saída
        case 5: codigo = 19; break; //Roteiro - Finalizado
      }
    } else {
      switch (item.IdRoteiroPedidoSituacao) {
        case 1: codigo = 20; break; //Entrega em aberto
        case 2: codigo = 3; break; //Check-in
        case 3: codigo = 4; break; //Início da Entrega
        case 4: codigo = 16; break; //RotaGPSAcao
        case 5: codigo = 17; break; //Recebimento recusado
        case 6: codigo = 5; break; //Entrega Realizada
        case 7: codigo = 15; break; //Entrega Realizada com exceção > criar com ponto de exclação
      }
    }

    let options = null;
    if(item.CodigoAcao == 20){
      options ={icone: 'Odometro'}
    }
    else if (informacoes.tipo == TipoEntregas.Coleta && ( item.IdRoteiroPedidoSituacao == 3 || item.IdRoteiroPedidoSituacao == 5 || item.IdRoteiroPedidoSituacao == 6 || item.IdRoteiroPedidoSituacao == 7)){
      options ={icone: 'RotaGPSAcaoColeta' + codigo.toString()}
    }
    else{
      options ={icone: 'RotaGPSAcao' + codigo.toString()}
    }

    icone=this.svgService.geraSVG(options)
    return this.sanitizer.bypassSecurityTrustResourceUrl(icone);
  }





  exibirClienteMapa(codigoCliente: number) {
    this.graphicService.retornarPontoCliente(codigoCliente);
  }

  exibirAcaoMapa(idCoordenada: number, checado: boolean) {
    checado = checado == null? true: !checado;
    let item = this.infoHistoricoAcoes.find(x => x.IdCoordenada == idCoordenada);
    item.check = checado;

    if (item) {
      item.TextoInfo = this.retornaAcao(item);
      item.Cliente = '';

      if (item.CodigoCliente > 0) {
        item.Cliente = item.CodigoCliente + ' - ' + item.RazaoSocial;
      }

      this.graphicService.criarPontoAcao(item, checado);
    }
  }

  marcarTodos(checado: boolean) {
    var itens = $("#timeline-acoes input:checkbox");
    if (!checado) {
      for (var i = 0; i < itens.length; i++) {
        if ($(itens[i])[0].checked == false) {
          this.exibirAcaoMapa($(itens[i])[0].value, true);
          $(itens[i])[0].checked = true;
        }
      }
    }
    else {
      for (var i = 0; i < itens.length; i++) {
        if ($(itens[i])[0].checked == true) {
          this.exibirAcaoMapa($(itens[i])[0].value, false);
          $(itens[i])[0].checked = false;
        }
      }
    }
  }

  alteraExibirTodos(){
    this.exibirTodos = !this.exibirTodos;
    this.marcarTodos(this.exibirTodos)
  }

  limpaBuscaAcao(){
    this.pesquisaAcoes = '';
  }

  downloadOdometro(){
    document.getElementById('btnDownloadCompOdometro').click();
  }

  async comprovanteEntrega(item){
    const modalElement = document.getElementById('popupID-dados-recebedor');
    const modalInstance = new bootstrap.Modal(modalElement);
    modalInstance.show();
    let pedidos = this.boxInfoRouterService.infoRouter.find((cliente: any) => cliente.CodigoCliente == item.CodigoCliente && cliente.IdPedidoConfirmacaoEntrega != null).pedidos;
    this.boxInfoRouterService.dadosComprovante = null;
    let idPedidoConfirmacaoEntrega = null;
    let contemConfirmacaoEntrega = pedidos.some((pedido) => pedido.IdPedidoConfirmacaoEntrega != null);
    if(contemConfirmacaoEntrega){
      idPedidoConfirmacaoEntrega = pedidos.find((pedido) => pedido.IdPedidoConfirmacaoEntrega != null).IdPedidoConfirmacaoEntrega
    }

    if(idPedidoConfirmacaoEntrega){
      let resultado = await this.boxInfoRouterService.getComprovante(idPedidoConfirmacaoEntrega);
    
      item.NomeRecebedor = resultado.NomeRecebedor;
      item.DocumentoRecebedor = resultado.DocumentoRecebedor;

      if(resultado.Arquivo){
          item.Arquivo = Util.decompress(resultado.Arquivo);
          this.boxInfoRouterService.dadosComprovante = item;
          this.boxInfoRouterService.dadosComprovante.pedidos = pedidos.filter((pedido) => pedido.IdPedidoConfirmacaoEntrega == idPedidoConfirmacaoEntrega);
      }
    }
    else{   
      this.notificationService.showInformativo('Comprovante não localizado');      
      setTimeout(() => {
        document.getElementById('btnCloseModalDadoRecebedor').click();        
      }, 1);  
    }
  }
}
